import OrganizerLayout from './OrganizerLayout';

export default OrganizerLayout;